import React from "react";
import homeaboutimg from '../assets/images/homeaboutimg.webp';
import gallry2 from '../assets/images/alumniassociatinimg.webp';
import gallry3 from '../assets/images/aboutbanner.webp';
const Museum = () =>{
    return(
        <div>
  <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">SVU Zoology Department Museum</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                    SVU Zoology Department Museum</p>
                </div>
            </section>
<section className="musem-main-sec  ">


    <div className="container">
    <p className="home-about-head text-center musem-head-color">SVU Zoology Department Museum</p>
    <p className="museum-main-para text-center">Welcome to the SVU Zoology Department Museum, a treasure trove of biodiversity that showcases a fascinating collection of preserved specimens, rare artifacts, and scientific exhibits. Our museum is home to a diverse array of zoological specimens. Each exhibit is carefully curated to educate and inspire students, researchers, and nature enthusiasts. Visitors can explore the wonders of zoological science, learn about
         evolutionary history, and gain insights into the rich biodiversity of our planet.</p>

         <div className="row museum-galley">
                        <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4">
<img src={homeaboutimg} className="gallery-img"  />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4">
<img src={gallry2} className="gallery-img"  />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4">
<img src={gallry3} className="gallery-img  banner-galley-img"  />
                        </div>
                    </div>
    </div>
   
</section>
        </div>


    )
}
export default Museum